import {
  dateFormatter, dateTimeFormatter, getLegalEntityName, infoLabelWithStatus,
} from '../../../utils/formatters';

const wayBillColumns = [
  {
    dataField: 'waybill_valid_from_date',
    text: 'Дата выдачи',
    formatter: (item, e) => infoLabelWithStatus(e?.status, dateFormatter(item)),
    headerClassName: 'apply-method-column-issueDate',
  },
  {
    dataField: 'waybill_valid_until_date',
    text: 'Срок действия',
    formatter: dateFormatter,
    headerClassName: 'apply-method-column-validityPeriod',
  },
  {
    dataField: 'waybill_dispatched_at',
    text: 'Дата и время выезда с парковки',
    formatter: dateTimeFormatter,
    headerClassName: 'apply-method-column-departureDateTime',
  },
  {
    dataField: 'waybill_returned_at',
    text: 'Дата и время возвращения',
    formatter: dateTimeFormatter,
    headerClassName: 'apply-method-column-returnDateTime',
  },
  {
    dataField: 'driver',
    text: 'Водитель',
    headerClassName: 'apply-method-column-carrier',
    formatter: item => item?.full_name,
  },
  {
    dataField: 'vehicle',
    text: 'Марка ТС',
    formatter: item => item?.vehicle_brand,
  },
  {
    dataField: 'vehicle',
    text: 'Модель ТС',
    formatter: item => item?.vehicle_model,
  },
  {
    dataField: 'vehicle',
    text: 'ГРН ТС',
    headerClassName: 'apply-method-column-vehicleLicensePlate',
    formatter: item => item?.vehicle_lpn,
  },
  {
    dataField: 'dictCarrier',
    text: 'Перевозчик',
    headerClassName: 'apply-method-column-carrier',
    formatter: getLegalEntityName,
  },
];

export default wayBillColumns;
